/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderDetailRocketFileVo
 */
export interface OrderDetailRocketFileVo {
    /**
     * 文件ID
     * @type {number}
     * @memberof OrderDetailRocketFileVo
     */
    id?: number;
    /**
     * 文件名
     * @type {string}
     * @memberof OrderDetailRocketFileVo
     */
    fileName?: string;
    /**
     * 文件URL
     * @type {string}
     * @memberof OrderDetailRocketFileVo
     */
    fileUrl?: string;
    /**
     * 文件类型 文件类型 1 物流附件 2 物流随函 3 装载列表 4 混合列表 5 移动发票 6 入库照片 7 韩国仓库入库早盘 8 韩国仓库出库照片 9 退货附件
     * @type {number}
     * @memberof OrderDetailRocketFileVo
     */
    fileType?: number;
}

/**
 * Check if a given object implements the OrderDetailRocketFileVo interface.
 */
export function instanceOfOrderDetailRocketFileVo(value: object): value is OrderDetailRocketFileVo {
    return true;
}

export function OrderDetailRocketFileVoFromJSON(json: any): OrderDetailRocketFileVo {
    return OrderDetailRocketFileVoFromJSONTyped(json, false);
}

export function OrderDetailRocketFileVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDetailRocketFileVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'fileType': json['fileType'] == null ? undefined : json['fileType'],
    };
}

export function OrderDetailRocketFileVoToJSON(json: any): OrderDetailRocketFileVo {
    return OrderDetailRocketFileVoToJSONTyped(json, false);
}

export function OrderDetailRocketFileVoToJSONTyped(value?: OrderDetailRocketFileVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileName': value['fileName'],
        'fileUrl': value['fileUrl'],
        'fileType': value['fileType'],
    };
}

